import React from 'react';
import PropTypes from 'prop-types';

import Configuration from './Configuration/Configuration';

function TemplateConfiguration(props) {
  const { match: { params: { id, name } } } = props;
  return (
    <Configuration
      organizationId={id}
      organizationName={decodeURIComponent(name)}
      isTemplate
    />
  );
}

export default TemplateConfiguration;

TemplateConfiguration.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
